(function () {

  'use strict';

  var ItxFilterItemCmp = {
    bindings: {
      filtersOpt: '<',
      isColor: '<',
      isSize: '<',
      modelSize: '<',
      onNewFilters: '&',
      reload: '<',
      text: '<',
      textSelected: '<',
      onAply: '&'
    },
    controller: ItxFilterItemCtrl,
    templateUrl: 'filter-item.component.html'
  };

  angular.module('itxApp.catalog')
    .component('itxFilterItem', ItxFilterItemCmp);

  ItxFilterItemCtrl.$inject = [
    '$scope',
    'ItxTranslateSvc',
    'ItxScreenSizeSvc'
  ];

  function ItxFilterItemCtrl(
    $scope,
    ItxTranslateSvc,
    ItxScreenSizeSvc
  ) {

    var _this = this;

    _this.isMobile = ItxScreenSizeSvc.isMobile();

    _this.isActive = false;

    _this.loadIndex = 5;
    _this.initIndex = 5;

    _this.showLessButton = false;
    _this.showMoreButton = false;

    _this.$onInit = function () {
      if(!_this.isSize) {
        _this.initPropiertiesSelected();
      } else {
        _this.initPropiertesSize();
      }
      _this.sortArray(true);
    };

    _this.$onChanges = function (c) {
      if ( c.reload && !c.reload.isFirstChange() && c.reload.currentValue != c.reload.previousValue ) {
        if(_this.isSize) {
          _this.setFiltersSize();
        }
        _this.sortArray();
      }
      if(c.textSelected && !c.textSelected.isFirstChange() && c.textSelected.currentValue != c.textSelected.previousValue){
        if(_this.textSelected === _this.filtersOpt.length){
          _this.showLessButton = false;
        } else {
          _this.showOrHideButtons();
        }
      }
    };
    
    _this.setFiltersSize = function() {
      _.forEach(_this.filtersOpt, function(item) { 
        item.selected = false;
        if(_this.modelSize[item.value]){
          item.selected = true;
        }
      });
    };

    _this.setSelected = function(item) {
      if(_this.modelSize[item.value]) {
        item.selected = true;
      } else {
        item.selected = false;
      }
      _this.onAply();
    };
    
    _this.initPropiertesSize = function() {
        var arrAux = [];
        _.forEach(_this.filtersOpt, function(item) {
          var objSize = { value: item, label: _this.getName(item), selected: false };
          for(var propertyName in _this.modelSize) {
            if(item === propertyName) {
              objSize.selected = true;
            }
          }
          arrAux.push(objSize);
        });
        _this.filtersOpt = arrAux;                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
    };

    _this.getName = function (size) {
      return size === '01' ? ItxTranslateSvc.translateCms('legacy.one_size') : size;
    };

    _this.initPropiertiesSelected = function () {
      _.forEach(_this.filtersOpt, function (item) {
        if (!item.hasOwnProperty('selected')) {
          item.selected = false;
        }
      });
    };

    _this.openFilter = function($event){        
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();    
      }
      _this.isActive = !_this.isActive;
    };

    _this.showOrHideButtons = function() {
      if(_this.initIndex === _this.loadIndex) {
        if(_this.loadIndex < _this.filtersOpt.length) {
          _this.showLessButton = false;
          _this.showMoreButton = true;
        }
      } else {
        if(_this.loadIndex > _this.initIndex) {
          _this.showLessButton = true;
          if(_this.loadIndex >= _this.filtersOpt.length) {
            _this.showMoreButton = false;
          } else {
            _this.showLessButton = false;
            _this.showMoreButton = true;
          }
        } else {
          if(_this.loadIndex === _this.filtersOpt.length) {
            _this.showMoreButton = false;
            _this.showLessButton = false;
          }
        }
      }

    };

    _this.orderByLetterSize = function (sizes) {
      const defaultSizes = joyr.constants.defaultSizes;
      return sizes.sort((a, b) => {
        let sortValueA = a.value; 
        let sortValueB = b.value; 
        if (a.value.indexOf('-') !== -1) {
          sortValueA = a.value.substring(0, a.value.indexOf('-'));
        }
        if (b.value.indexOf('-') !== -1) {
          sortValueB = b.value.substring(0, b.value.indexOf('-'));
        }
        return b.selected - a.selected || defaultSizes[sortValueA] - defaultSizes[sortValueB]
      });
    }

    _this.sortArray = function (collapse) {

      if (_this.isSize) {
        _this.filtersOpt = _.orderBy(_this.filtersOpt, ['selected', 'value'], ['desc', 'asc']);
        _this.filtersOpt = _this.orderByLetterSize(_this.filtersOpt);
      } else {
        _this.filtersOpt.sort(function (left, right) {
            return right.selected - left.selected || right.label - left.label;
        });
      }
      
      var selected = _.filter(_this.filtersOpt, function (attr) {
        return attr.selected === true;
      });
      
      if(collapse){
        if (selected.length >= _this.loadIndex) {
          _this.loadIndex = selected.length;
        } else {
          _this.loadIndex = _this.initIndex;
        }
        _this.showOrHideButtons();
      }
    };

    _this.sortArrayLessButton = function () {

      _this.filtersOpt.sort(function (left, right) {
        if (_this.filtersOpt.indexOf(left) > _this.initIndex - 1 && _this.filtersOpt.indexOf(right) > _this.initIndex - 1) {
          return right.selected - left.selected || right.label - left.label;
        } else {
          return 0;
        }
      });

      var selected = _.filter(_this.filtersOpt, function (attr) {
        return attr.selected === true;
      });
      var lastItemSelected = _this.filtersOpt.indexOf(selected[selected.length - 1]) + 1;

      if (lastItemSelected >= _this.initIndex) {
        _this.loadIndex = lastItemSelected;
      } else {
        _this.loadIndex = _this.initIndex;
      }
      _this.showOrHideButtons();
    };

    _this.showMore = function () {
      if (_this.loadIndex < _this.filtersOpt.length) {
        _this.loadIndex += (_this.filtersOpt.length - _this.initIndex);
      }
      _this.showOrHideButtons();
    };

    _this.showLess = function () {
      if (_this.loadIndex > _this.initIndex) {
        _this.loadIndex -= _this.initIndex;
        _this.sortArrayLessButton();
      }
      _this.showOrHideButtons();
    };

  }

})();
